import { captureChatMessage } from 'shared/sentry';
import { createClient } from 'matrix-js-sdk';
import { patchMatrixMediaHandlerVideoQuality } from './matrixMediaHandlerVideoQuality';

patchMatrixMediaHandlerVideoQuality();

/**
 * Create a Matrix JS SDK client with VoIP-friendly defaults.
 * Extra keys are passed through to `createClient` (caller overrides win).
 * @param {{ baseUrl: string, userId: string, accessToken: string, deviceId?: string, [key: string]: * }} opts
 */
export function createMatrixClient({ baseUrl, userId, accessToken, deviceId, ...clientOpts } = {}) {
  if (typeof baseUrl !== 'string' || !baseUrl.trim()) {
    captureChatMessage('Matrix createMatrixClient: baseUrl is missing or invalid', 'warning', {
      tags: { matrix: 'client' },
    });
  }
  return createClient({
    forceTURN: true,
    fallbackICEServerAllowed: true,
    iceCandidatePoolSize: 8,
    baseUrl,
    userId,
    accessToken,
    deviceId,
    ...clientOpts,
  });
}
